import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const CheckboxWrapper = styled.div`
  margin: 0.5rem 0;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${Colors.text_Color_1};
  font-size: 0.75em;
  font-weight: 400;
  cursor: pointer;
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  accent-color: '${Colors.primary || '#007bff'}';
  cursor: pointer;
`;

export const Error = styled.p`
  margin-top: 0.3rem;
  color: ${Colors.ftColor6 || 'red'};
  font-size: 0.7em;
  font-weight: 300;
`;
